<template>
  <div>
    <b-alert v-if="staleMessage" variant="warning" show dismissible @dismissed="staleMessage = ''">
      {{ staleMessage }}
    </b-alert>
    <b-form inline class="mb-3 col-md-9 pl-0">
      <div class="col pl-0">
        <label v-if="variantIndex===0">Name</label>
        {{variant.title}}
      </div>
      <div class="col" style="max-width: 120px">
        <variant-list-input name="Anzahl" :index="variantIndex" type="number" v-model="quantity" :state="quantityState">
          <b-form-invalid-feedback :state="quantityState">{{ quantityError }}</b-form-invalid-feedback>
        </variant-list-input>
      </div>
      <div class="col">
        <b-button :disabled="!isDirty" :variant="isDirty ? 'primary' : 'secondary'" @click="update">Speichern
          <b-spinner v-if="inProgress" small></b-spinner>
        </b-button>
      </div>
    </b-form>
  </div>
</template>
<script>
import VariantListInput from "@/pages/EditProductPage/Variants/VariantListInput";
import inventory from "@/api/inventory";
import {handleError} from "@/utils/errors";
import {
  INVALID_QUANTITY_MESSAGE, findCurrentQuantity, parseInventoryError, parseQuantity, staleQuantityMessage
} from "@/utils/inventory";
export default {
  inject: ['showSuccessAlert'],
  props: ['variant', 'variantIndex'],
  components: {VariantListInput},
  data(){
    return {
      quantity: 0,
      savedQuantity: 0,
      inProgress: false,
      staleMessage: '',
      serverErrors: []
    }
  },
  created() {
    this.savedQuantity = this.inventoryLevel.quantities[0].quantity;
    this.quantity = this.savedQuantity;
  },
  watch: {
    variant() {
      this.savedQuantity = this.inventoryLevel.quantities[0].quantity;
    },
    quantity() {
      this.serverErrors = [];
    }
  },
  computed:{
    inventoryLevel() {
      return this.variant.inventoryItem.inventoryLevels[0];
    },
    parsedQuantity() {
      return parseQuantity(this.quantity);
    },
    quantityError() {
      if (this.serverErrors.length > 0) return this.serverErrors.join(' ');
      return this.parsedQuantity === null ? INVALID_QUANTITY_MESSAGE : '';
    },
    quantityState() {
      return this.quantityError ? false : null;
    },
    isDirty() {
      return this.parsedQuantity !== null && this.parsedQuantity !== this.savedQuantity;
    }
  },
  methods: {
    update() {
      if (this.isDirty) {
        const quantity = this.parsedQuantity;
        this.inProgress = true;
        this.staleMessage = '';
        inventory.update(
            this.variant.product.id,
            this.variant.inventoryItem.id,
            quantity,
            this.savedQuantity,
            this.inventoryLevel.location.id
        ).then(() => {
              this.storeSavedQuantity(quantity);
              this.showSuccessAlert("Änderung ist gespeichert");
            }
        ).catch((error) => {
            const result = parseInventoryError(error);
            if (result.stale) {
              // Never retry here: the user has to see the new stock and decide again.
              return this.onStaleQuantity(result.currentQuantities);
            }
            this.serverErrors = result.fieldErrors;
            if (result.fieldErrors.length === 0 || result.message) {
              handleError({vm: this, error: result.message || error});
            }
        }).finally(() => {
            this.inProgress = false
        })
      }
    },
    onStaleQuantity(currentQuantities) {
      const current = findCurrentQuantity(
          currentQuantities, this.variant.inventoryItem.id, this.inventoryLevel.location.id
      );
      if (current !== undefined) {
        this.storeSavedQuantity(current);
        this.staleMessage = staleQuantityMessage(current);
        return;
      }
      this.staleMessage = staleQuantityMessage();
      return this.$store.dispatch('products/refreshInventory', {productId: this.variant.product.id})
          .then(() => {
            this.savedQuantity = this.inventoryLevel.quantities[0].quantity;
            this.staleMessage = staleQuantityMessage(this.savedQuantity);
          })
          .catch(error => handleError({vm: this, error}));
    },
    storeSavedQuantity(quantity) {
      this.savedQuantity = quantity;
      this.$store.commit('products/setInventoryQuantity', {
        inventoryItemId: this.variant.inventoryItem.id,
        locationId: this.inventoryLevel.location.id,
        quantity
      });
    }
  }
}
</script>
